import { render, staticRenderFns } from "./CertificatAuthority.vue?vue&type=template&id=3acbe36a&scoped=true&"
import script from "./CertificatAuthority.vue?vue&type=script&lang=js&"
export * from "./CertificatAuthority.vue?vue&type=script&lang=js&"
import style0 from "./CertificatAuthority.vue?vue&type=style&index=0&id=3acbe36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acbe36a",
  null
  
)

export default component.exports